import {
    HStack,
    VStack,
    Text,
    Tooltip,
    Tag,
    Spinner,
    ModalOverlay,
    ModalHeader,
    ModalContent,
    Modal,
    ModalBody,
    ModalCloseButton,
    PopoverTrigger,
    Popover,
    PopoverBody,
    PopoverContent,
    Box,
    StackDivider,
} from '@chakra-ui/react';
import { ResourceBlockViewProps, BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentResourceView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<ResourceBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem {...props.block}>
                <HStack
                    w="full"
                    bg="whiteAlpha.50"
                    px={5}
                    py={3}
                    borderRadius="md"
                    justify="space-between"
                >
                    <VStack align="start" spacing={0}>
                        <Text fontWeight="semibold" color="whiteAlpha.800">
                            {props.label}
                        </Text>
                        <Text color="whiteAlpha.600">{props.caption}</Text>
                    </VStack>
                    <Popover
                        trigger="hover"
                        placement="top"
                        closeDelay={0}
                        openDelay={300}
                    >
                        <PopoverTrigger>
                            <Tag {...props.status.tag} size="lg" userSelect="none">
                                <HStack spacing={3}>
                                    <Text>{props.status.title}</Text>
                                    {props.status.isLoading && (
                                        <Spinner size="sm" speed="3s" />
                                    )}
                                </HStack>
                            </Tag>
                        </PopoverTrigger>
                        <PopoverContent
                            bg="black"
                            w="20rem"
                            fontSize="sm"
                            overflow="hidden"
                        >
                            <PopoverBody p={3} bg="whiteAlpha.200">
                                <VStack
                                    align="start"
                                    spacing={2}
                                    w="full"
                                    divider={
                                        <StackDivider borderColor="whiteAlpha.200" />
                                    }
                                >
                                    <HStack justify="space-between" w="full">
                                        <HStack spacing={2}>
                                            <Box
                                                borderRadius="full"
                                                w={2}
                                                h={2}
                                                bg={`${props.status.tag.colorScheme}.300`}
                                            />
                                            <Text
                                                fontWeight="semibold"
                                                color="whiteAlpha.800"
                                            >
                                                {props.status.title}
                                            </Text>
                                        </HStack>
                                        <Text color="whiteAlpha.600" fontSize="xs">
                                            {props.status.timestamp.relative.label}
                                        </Text>
                                    </HStack>
                                    <Text color="whiteAlpha.600">
                                        {props.status.description}
                                    </Text>
                                </VStack>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </HStack>
                <Modal {...props.inspect.modal} returnFocusOnClose={false} size="2xl">
                    <ModalOverlay />
                    <ModalCloseButton />
                    <ModalContent _focus={{ outline: 'none' }}>
                        <ModalHeader>Inspect</ModalHeader>
                        <ModalBody fontSize="sm">
                            <Text as="pre" whiteSpace="pre-wrap">
                                {props.configuration.raw}
                            </Text>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </BlockItem>
        );
    };
}
